import type { LocationDtoV3 } from '../../generated-api';

export enum CashDrawerStatus {
  NOT_FOUND = 'not found', // There is no cash register found for the location selected in the app
  CONNECTED = 'connected', // The app has a connection to a cash register
  DISCONNECTED = 'disconnected', // There is a cash register for the location, however it is currently not connected to the app
  ERROR = 'error', // There is a cash register for the location, however it is in an error state.
}

// Read synchronously rather than via useQuery. A synchronous queryFn resolves with no async
// boundary, so on react-query 5.101 (which notifies on every setOptions) the observer
// resolved+notified within the same render cycle, driving a self-sustaining re-render loop
// (issue #1027). localStorage is the source of truth and the read is cheap.
export const useCashStatus = (): CashDrawerStatus => {
  const status = localStorage.getItem('cash_drawer_state');
  return (status ?? CashDrawerStatus.NOT_FOUND) as CashDrawerStatus;
};

export const useShouldDisplayCashButton = (location: LocationDtoV3): boolean => {
  const cashStatus = useCashStatus();

  const isUk = location.countryCode === 'UK';
  const cashDrawerMissing = cashStatus === CashDrawerStatus.NOT_FOUND;

  return !isUk && !cashDrawerMissing;
};
